import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getCompanyById, getOwnersCompany } from "~/store/selectors/selector.companies";

export const useCreateProjectFromEstimate = (estimate) => {
  const estimateCompany = useSelector((state) =>
    estimate?.company_id ? getCompanyById(state, estimate.company_id) : null
  );
  const ownerCompany = useSelector(getOwnersCompany);

  const estimateData = useMemo(() => {
    if (!estimate) return null;

    if (!estimateCompany || estimateCompany?.is_archived || estimateCompany?.is_trashed) {
      return { ...estimate, company_id: ownerCompany.id };
    }
    return estimate;
  }, [estimate, estimateCompany, ownerCompany.id]);

  return estimateData;
};
